import React from "react";
import { Row, Col } from "reactstrap";
import TableWrapper from "@/utils/TableWrapper";
import type { TableWrapperProps } from "@/utils/TableWrapper";

/**
 * SCRUM-1155: the last of the seven lists from SCRUM-1026. The page overview
 * renders through TableWrapper, so this view no longer carries a search box, a
 * pager or a hand-rolled `.slice()`. The container keeps the FilterContainer
 * chips and the newest-first order and hands the result in as `data`, so the
 * headers additionally become sortable.
 *
 * Known consequences, recorded rather than discovered (SCRUM-1026 accepts them):
 * the "Search by page type/template" box becomes TableWrapper's all-column box —
 * which is wider on purpose, since the old one could not find a product page by
 * its product's name — and an empty result now says "No data available" instead
 * of rendering an empty table body. The missing accessible name on the search
 * box belongs to TableWrapper (SCRUM-1149). Page size was already 10 and stays.
 *
 * SCRUM-1811: `pages` is now ONE page the server answered, so TableWrapper runs
 * in its manual mode: the container owns the page index and the search text,
 * and `rowCount` is the server's total. The search box therefore searches
 * `global_title` and `page_configuration.path` across the whole site (the `q`
 * of GET /api/pages) and no longer the target's name — the accepted cost of
 * Dirk's option (b) on SCRUM-1654. A header click sorts the rows on screen only.
 */
export type PagesViewProps = {
  pages: TableWrapperProps<unknown>["data"];
  columns: TableWrapperProps<unknown>["columns"];
  rowCount: number;
  pagination: TableWrapperProps<unknown>["pagination"];
  onPaginationChange: TableWrapperProps<unknown>["onPaginationChange"];
  searchValue: string;
  onSearchChange: TableWrapperProps<unknown>["onSearchChange"];
};

const PagesView = ({
  pages,
  columns,
  rowCount,
  pagination,
  onPaginationChange,
  searchValue,
  onSearchChange,
}: PagesViewProps) => {
  return (
    <>
      <Row style={{ marginBottom: "-25px" }}>
        <Col md="12" sm="12" />
      </Row>

      <TableWrapper
        data={pages}
        columns={columns}
        manualPagination
        rowCount={rowCount}
        pagination={pagination}
        onPaginationChange={onPaginationChange}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
      />
    </>
  );
};

export default PagesView;
